<template>
  <div class="container">
    <cta-banner
      v-if="blockData && blockData.sys.contentType.sys.id === 'cta'"
      :cta-data="blockData"
      :theme="'default'"
      :mascot-position="blockData.fields.mascotPosition || 'right'"
    />
    <text-block
      v-else-if="blockData && blockData.sys.contentType.sys.id === 'textBlock'"
      :text-block-data="blockData"
    />
    <news-block
      v-else-if="blockData && blockData.sys.contentType.sys.id === 'newsBlock'"
      :news-block-data="blockData"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  blockData?: any
}

const props = defineProps<Props>()

// Use the provided block data directly, no need to fetch
const blockData = computed(() => props.blockData)
</script>
